import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'
import { compileSetTable } from './set-table'
import { compileTreatmentByOrder } from './treatment-by-order'
import { compileTreatmentByPayment } from './treatment-by-payment'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectMonthList = (state) => {
    return selectOwnState(state).monthList
}

export const calculateSetReport = (state) => {
    const monthList = selectMonthList(state)
    return compileSetTable(monthList)
}

export const calculateTreatmentByOrder = (state) => {
    const monthList = selectMonthList(state)
    return compileTreatmentByOrder(monthList)
}

export const calculateTreatmentByPayment = state => {
    const monthList = selectMonthList(state)
    return compileTreatmentByPayment(monthList)
}




// WEBPACK FOOTER //
// ./src/modules/analytics/state/basis/selector.js